// extracted by mini-css-extract-plugin
export default {"container":"C5yHzSo5"};